import reducer from './reducer';
import epic from './epic';


export default {
  reducer,
  epic,
};
